import React from 'react'

import styled from 'styled-components'

import MovieCreationIcon from '@mui/icons-material/MovieCreation'
import DescriptionIcon from '@mui/icons-material/Description'
import MusicNoteIcon from '@mui/icons-material/MusicNote'
import BrushIcon from '@mui/icons-material/Brush'
import VideocamIcon from '@mui/icons-material/Videocam'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy'
import BusinessIcon from '@mui/icons-material/Business'
import LanguageIcon from '@mui/icons-material/Language'
import TranslateIcon from '@mui/icons-material/Translate'

import { useStore } from './useStore'

export default function FilmComp({ film, setDirector, setWriter, setActor, setComposer, setProdDesigner, setCinematographer, addReqGenre, setStudio, setCountry, setLanguage }) {
    const visibility = useStore(state => state.visibility)
    return (
        <ListItemContainer>
            <a
                href={'https://letterboxd.com/film/' + film.url}
                target="_blank"
                rel="noreferrer"
            >
                <ItemImage src={film.poster} />
            </a>
            <FilmProps>
                <FilmTitleCont>
                    <FilmLink
                        href={'https://letterboxd.com/film/' + film.url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FilmTitle>{film.title}</FilmTitle>
                    </FilmLink>
                    ({film.year})
                </FilmTitleCont>
                <RatingNumCont>
                    <RatingCont>{film.rating.toFixed(1)}</RatingCont>
                    <NumCont># {film.num}</NumCont>
                </RatingNumCont>
                {visibility.directors &&
                    <ListItemsProp
                        PropIcon={MovieCreationIcon}
                        items={film.directors}
                        more={film.moreDirectors}
                        itemClicked={setDirector}
                    />
                }
                {visibility.actors &&
                    <ListItemsProp
                        PropIcon={PeopleAltIcon}
                        items={film.actors}
                        more={false}
                        itemClicked={setActor}
                    />
                }
                {visibility.writers &&
                    <ListItemsProp
                        PropIcon={DescriptionIcon}
                        items={film.writers || []}
                        more={false}
                        itemClicked={setWriter}
                    />
                }
                {visibility.cinematographers &&
                    <ListItemsProp
                        PropIcon={VideocamIcon}
                        items={film.cinematographers || []}
                        more={film.moreCinematographers}
                        itemClicked={setCinematographer}
                    />
                }
                {visibility.prodDesigners &&
                    <ListItemsProp
                        PropIcon={BrushIcon}
                        items={film.prodDesigners || []}
                        more={false}
                        itemClicked={setProdDesigner}
                    />
                }
                {visibility.composers &&
                    <ListItemsProp
                        PropIcon={MusicNoteIcon}
                        items={film.composers || []}
                        more={false}
                        itemClicked={setComposer}
                    />
                }
                {visibility.genres &&
                    <ListItemsProp
                        PropIcon={TheaterComedyIcon}
                        items={film.genres}
                        more={false}
                        itemClicked={addReqGenre}
                    />
                }
                {visibility.studios &&
                    <ListItemsProp
                        PropIcon={BusinessIcon}
                        items={film.studios || []}
                        more={film.moreStudios}
                        itemClicked={setStudio}
                    />
                }
                {visibility.countries &&
                    <ListItemsProp
                        PropIcon={LanguageIcon}
                        items={film.countries || []}
                        more={film.moreCountries}
                        itemClicked={setCountry}
                    />
                }
                {visibility.language &&
                    <ListItemsProp
                        PropIcon={TranslateIcon}
                        items={film.language ? [film.language] : []}
                        itemClicked={setLanguage}
                    />
                }
            </FilmProps>
        </ListItemContainer>
    )
}

const ListItemContainer = styled.div`
  display: flex;
  padding: 15px 10px 15px 10px;
  border-bottom: 1px solid #3b3b3b;
`;

const ItemImage = styled.img`
  width: 115px;
  height: 172.5px;
  margin-right: 10px;
  object-fit: cover;
  border: 1px solid #3b3b3b;
`;

const FilmProps = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 7px;
`

const FilmLink = styled.a`
  color: inherit;
  text-decoration: none;
  &:hover {
    color: #ccc;
  }
`

const FilmTitleCont = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

const FilmTitle = styled.div`
  font-size: 115%;
  /* background-color: #333; */
`
const RatingNumCont = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    color: #ddd;
`

const RatingCont = styled.div`
    font-size: 130%;
    color: #fdc187;
`

const NumCont = styled.div`
    font-size: 110%;
`

function ListItemsProp({ PropIcon, items, more, itemClicked }) {
    return (
        <ListItemPropCont>
            {PropIcon && 
                <PropIcon 
                    style={{fontSize: 20, color: '#777'}}
                />
            }
            <ListItemCont>
                {items.map((item, index) => (
                    <ListItem
                        key={item}
                        onClick={() => itemClicked(item)}
                    >
                        {(index < items.length - 1 || more) ? item + ',' : item}
                    </ListItem>
                ))}
                { more && '...'}
            </ListItemCont>
        </ListItemPropCont>
    )
}

const ListItemPropCont = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

const ListItemCont = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 5px;
`

const ListItem = styled.span`
    cursor: pointer;
    color: #ddd;
    &:hover {
        color: #aaa;
    }
`
